import React from 'react';
import { ExternalLink } from 'lucide-react';
import { services } from '../data/mockData';

const ServicesSection = () => {
  return (
    <section id="services" className="bg-white py-6">
      <div className="max-w-6xl mx-auto px-6">
        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative overflow-hidden cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-[450px] overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>

              {/* Content Overlay */}
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <h3 className="text-xl font-bold text-white mb-3 tracking-[0.05em] flex items-center gap-2" style={{ fontFamily: 'Georgia, serif' }}>
                  {service.title}
                  {service.external && <ExternalLink size={16} />}
                </h3>
                <p className="text-white/80 text-xs leading-relaxed mb-4">
                  {service.description}
                </p>
                <a
                  href={service.link}
                  target={service.external ? "_blank" : "_self"}
                  rel={service.external ? "noopener noreferrer" : ""}
                  className="inline-flex items-center text-white text-xs tracking-[0.15em] hover:text-gray-300 transition-colors"
                >
                  {service.external ? "Visit Now" : "View More"}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
